import { gql } from 'graphql-tag'

const ScoreThresholdFragment = gql`
  fragment ScoreThresholdFragment on ScoreThreshold {
    high
    low
  }
`

const SectionThresholdFragment = gql`
  fragment SectionThresholdFragment on SectionThreshold {
    station {
      high
      low
    }
    sales {
      high
      low
    }
    wastage {
      high
      low
    }
  }
`

const ScoreCardThresholdsFragment = gql`
  fragment ScoreCardThresholdsFragment on ScoreCardThresholds {
    incentiveSales {
      ...ScoreThresholdFragment
    }
    thumbsUp {
      ...ScoreThresholdFragment
    }
    toiletCheck {
      ...ScoreThresholdFragment
    }
    budgetEfficiency {
      ...ScoreThresholdFragment
    }
    totalBudgetEfficiency {
      ...ScoreThresholdFragment
    }
    targetEfficiency {
      ...ScoreThresholdFragment
    }
    feelingMeterAverage {
      ...ScoreThresholdFragment
    }
    feelingMeterUsage {
      ...ScoreThresholdFragment
    }
    dailyChecklistUsage {
      ...ScoreThresholdFragment
    }
    dailyInfoUsage {
      ...ScoreThresholdFragment
    }
    totalSalesEfficiency {
      ...ScoreThresholdFragment
    }
    hourlyHallChecklistUsage {
      ...ScoreThresholdFragment
    }
    hourlyBuffetChecklistUsage {
      ...ScoreThresholdFragment
    }
    hourlyVitrineChecklistUsage {
      ...ScoreThresholdFragment
    }
    sectionTotals {
      ...SectionThresholdFragment
    }
    impulseSales {
      ...ScoreThresholdFragment
    }
    otherThresholds {
      value {
        high
        low
      }
      name
    }
  }
  ${ScoreThresholdFragment}
  ${SectionThresholdFragment}
`

export const fetchStationScoreCardThresholds = gql`
  query fetchScoreCardThresholds($stationId: ID!) {
    stationScoreCardThresholds(stationId: $stationId) {
      ...ScoreCardThresholdsFragment
    }
  }
  ${ScoreCardThresholdsFragment}
`

export const fetchChainScoreCardThresholds = gql`
  query fetchChainScoreCardThresholds {
    chainScoreCardThresholds {
      ...ScoreCardThresholdsFragment
    }
  }
  ${ScoreCardThresholdsFragment}
`

export const upsertScoreCardThresholds = gql`
  mutation upsertScoreCardThresholds($data: ScoreCardThresholdsInput!) {
    upsertScoreCardThresholds(data: $data) {
      ...ScoreCardThresholdsFragment
    }
  }
  ${ScoreCardThresholdsFragment}
`
